<app-page-header title="Home" active_item="Monitoramento" titleLink="/monitoring"></app-page-header>


<app-metabase-public-embed
  [url]="'https://reports.harpiatechnology.io/public/dashboard/7bd75425-1a67-45db-92c0-0227b2581d17'"
>
</app-metabase-public-embed>

